import React from "react";
import { Link } from 'react-router-dom';

const BidCard = ({
    provider_name,
    bid_amount,
    is_pro_provider,
    avatar,
    insured,
    licensed,
    provider_bidded_date,
    provider_id,
    rating_all_together,
    reviews_all_together,
    years_of_experience,
    bid_type,
    down_payment,
    hours,
    remaing_amount,
    total,
    project_id,
    provider_user_id,
    provider_project_id,
    project_number,
    provider_phone_number,
    unavailable_user,
    is_available,
    provider_deleted,
    provider_email,
    provider_hired
}) => {
    const redirectData = {
        pathname: `/bid-details/${project_id}/${provider_project_id}/bid`,
        // state: {
        //     type: "hired",
        //     project_id: project_id,
        //     provider_project_id: provider_project_id,
        //     tab: 0
        // }
    };
    console.log(provider_deleted, "provider_deleted", is_available);

    return (
            <div className="ec-card__wrap position-relative" style={{ maxWidth: '600px', margin: '0 auto' }}>
                <div className="ec-ip__ncard" style={{ 
                    padding: '20px',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    border: '1px solid #eee'
                }}>
                    <Link className="w-100" to="#" onClick={(e) => e.preventDefault()}>
                        <div className="ec-ip__ncard-header d-flex justify-content-between">
                            <div className="ec-ip__ncard-header-left d-flex">
                                <img 
                                    src={(avatar && avatar.length > 0) ? avatar : "/assets/images/New-files/default-card-img-a.png"} 
                                    alt="" 
                                    className="ec-ip__ncard-header-avatar ec-nproject__avatar mr-3" 
                                    style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
                                />
                                <div className="ec-ip__ncard-header-data ">
                                    <div className="d-flex justify-content-left">
                                        <span><p className="ec-ip__ncard-header-data-title ec-nproject__title" style={{ fontSize: '16px', fontWeight: '600', marginBottom: '4px' }}>{provider_name}</p></span>
                                        {is_pro_provider &&
                                            <span className="ec-ip__ncard-header-data-badge ec-nproject__badge ml-2" style={{ backgroundColor: '#FFD700', padding: '2px 8px', borderRadius: '12px', fontSize: '12px' }}>Pro+</span>
                                        }
                                    </div>
                                    <div className="ec-ip__ncard-header-data-rating d-flex align-items-center" style={{ fontSize: '14px' }}>
                                        <div className="ec-ip__ncard-header-data-rating-num ec-nproject__rating-blurb">
                                            <span>{rating_all_together}</span>
                                            <span className="ml-1">
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFD700">
                                                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                                                </svg>
                                            </span>
                                        </div>
                                        <div className="ec-ip__ncard-header-data-rating-count ec-nproject__rating-count ml-2 mr-2">{reviews_all_together} ratings</div>
                                        <div className="ec-ip__ncard-header-data-rating-yrcount ec-nproject__rating-ycount">{years_of_experience}+ years</div>
                                    </div>
                                </div>
                            </div>
                            <div className="ec-ip__ncard-header-right">
                                <div className="ec-ip__ncard-header-date" style={{ fontSize: '13px', color: '#666' }}>{provider_bidded_date}</div>
                                <div className="ec-ip__ncard-header-bid-blurb ec-nproject__bid-blurb mt-1">
                                    <p className="ec-ip__ncard-header-bid-title" style={{ color: '#007bff' }}>{provider_hired ? 'Hired' : 'Bid' }</p>
                                    <img src="/assets/images/New-files/hammer-blue-icon.svg" alt="" className="ml-2 ec-ip__ncard-header-bid-icon" style={{ width: '14px' }}/>
                                </div>
                            </div>
                        </div>
                    </Link>

                    {/* Price section with reduced margins */}
                    {(bid_type && bid_type === "fixed") ?
                        <div className="ec-ip__ncard-price mt-3">
                            <div className="ec-ip__ncard-price-bid d-flex justify-content-between mb-2">
                                <div className="ec-ip__ncard-price-bid-title" style={{ fontSize: '14px' }}>Bid Amount</div>
                                <div className="ec-ip__ncard-price-bid-amount" style={{ fontWeight: '600' }}>${bid_amount}</div>
                            </div>
                            <div className="ec-ip__ncard-price-total d-flex justify-content-between mb-2">
                                <div className="ec-ip__ncard-price-total-title" style={{ fontSize: '14px' }}>Total</div>
                                <div className="ec-ip__ncard-price-total-amount" style={{ fontWeight: '600' }}>${total}</div>
                            </div>
                        </div> :
                        <div className="ec-ip__ncard-price mt-3">
                            <div className="ec-ip__ncard-price-bid d-flex justify-content-between mb-1">
                                <div className="ec-ip__ncard-price-bid-title">Bid Amount</div>
                                <div className="ec-ip__ncard-price-bid-amount">${bid_amount}/hr</div>
                            </div>
                            <div className="ec-ip__ncard-price-approx d-flex justify-content-between pb-2">
                                <div className="ec-ip__ncard-price-approx-title">Approx. hr</div>
                                <div className="ec-ip__ncard-price-approx-amount">{hours} hr</div>
                            </div>
                            <div className="ec-ip__ncard-price-total d-flex justify-content-between mb-2">
                                <div className="ec-ip__ncard-price-total-title">Total</div>
                                <div className="ec-ip__ncard-price-total-amount">${total}</div>
                            </div>
                        </div>
                    }

                    {/* Contact buttons with icons */}
                    <div style={{ display: 'flex', gap: '8px', marginTop: '15px' }}>
                        <button
                            onClick={() => { window.location.href = `tel:${provider_phone_number}` }}
                            className="phone-button"
                        >
                            <span style={{ fontWeight: '600' }}>{provider_phone_number}</span>
                            <span>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                                </svg>
                            </span>
                        </button>

                        <button
                            onClick={() => { window.location.href = `sms:${provider_phone_number}?&body=I found your profile on EasyBids and want to discuss my project with you.` }}
                            className="sms-button"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"/>
                            </svg>
                            SMS
                        </button>

                        <button
                            onClick={() => { window.open(`mailto:${provider_email}?subject=Project Inquiry&body=I found your profile on EasyBids and want to discuss my project with you`, '_blank') }}
                            className="email-button"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                            </svg>
                            Email
                        </button>
                    </div>

                    {/* View Bid Proposal button with updated style */}
                    <div className="ec-ip__ncard__footer d-flex flex-wrap justify-content-end mt-3">
                        <Link 
                            to={`/bid-details-price/${project_number}/${project_id}/${provider_project_id}/bid`} 
                            className="ec-button__primary w-100 text-center"
                            style={{
                                backgroundColor: '#f8f9fa',
                                color: '#007bff',
                                border: '1px solid #007bff',
                                borderRadius: '8px',
                                padding: '10px',
                                textDecoration: 'none',
                                fontSize: '14px',
                                fontWeight: '600',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            {provider_hired ? 'View Accepted Bid' : 'View Bid Proposal'}
                        </Link>
                    </div>
                </div>
            </div>
    )
}
export default BidCard;